<template>
	<CRow>
		<CCol col="12">
			<CCard>
				<CCardHeader>Résumé en graphique</CCardHeader>
				<CCardBody>
					<CRow>
						<CCol col="6">
							<vc-date-picker
								v-model="searchStartDate"
								:model-config="modelConfig"
								:masks="masks"
								mode="date"
							>
								<template v-slot="{ inputValue, inputEvents }">
									<div role="group" class="form-group">
										<label>Date de début</label>
										<div class="input-group">
											<input
												type="string"
												class="form-control"
												:value="inputValue"
												v-on="inputEvents"
											/>
											<div class="input-group-append">
												<span class="input-group-text">
													<CIcon name="cil-calendar" />
												</span>
											</div>
											<small class="form-text text-muted w-100"
												>Exemple: 06/12/2021</small
											>
										</div>
									</div>
								</template>
							</vc-date-picker>
						</CCol>

						<CCol col="6">
							<vc-date-picker
								v-model="searchEndDate"
								:model-config="modelConfig"
								:masks="masks"
								mode="date"
							>
								<template v-slot="{ inputValue, inputEvents }">
									<div role="group" class="form-group">
										<label>Date de fin</label>
										<div class="input-group">
											<input
												type="string"
												class="form-control"
												:value="inputValue"
												v-on="inputEvents"
											/>
											<div class="input-group-append">
												<span class="input-group-text">
													<CIcon name="cil-calendar" />
												</span>
											</div>
											<small class="form-text text-muted w-100"
												>Exemple: 06/12/2021</small
											>
										</div>
									</div>
								</template>
							</vc-date-picker>
						</CCol>
					</CRow>

					<template v-if="loading">
						<Loading />
					</template>

					<template v-else>
						<h4 class="text-center">Types de colis vendus</h4>
						<summary-graph-recap-table :totals-product-types="totalsProductTypes" />

						<h4 class="text-center">Quantité de colis vendus</h4>
						<CChartBar
							style="height: 300px"
							:options="{ maintainAspectRatio: false }"
							:datasets="datasetPackages"
							labels="months"
						/>

						<h4 class="text-center">Chiffre d'affaires de colis vendus</h4>
						<CChartLine
							style="height: 300px"
							:options="{ maintainAspectRatio: false }"
							:datasets="datasetCA"
							labels="months"
						/>
					</template>
				</CCardBody>
			</CCard>
		</CCol>
	</CRow>
</template>

<script>
	import { CChartLine, CChartBar } from '@coreui/vue-chartjs';
	import { minBy, map } from 'lodash';
	import Loading from '../../components/loading';
	import SummaryGraphRecapTable from './summary-graph-recap-table';

	export default {
		name: 'summary-graph',
		components: { SummaryGraphRecapTable, Loading, CChartLine, CChartBar },

		data() {
			return {
				loading: false,
				masks: {
					input: 'DD/MM/YYYY',
				},
				modelConfig: {
					type: 'string',
					mask: 'YYYY-MM-DD',
				},
				searchStartDate: this.$moment().startOf('year').format('YYYY-MM-DD'),
				searchEndDate: this.$moment().format('YYYY-MM-DD'),
				totalsProductTypes: {},
				datasetPackages: [],
				datasetCA: [],
			};
		},

		mounted() {
			this.getDatas();
		},

		watch: {
			searchStartDate() {
				this.getDatas();
			},

			searchEndDate() {
				this.getDatas();
			},
		},

		methods: {
			getDatas() {
				this.loading = true;
				this.$axios
					.get(
						`/api/slips/stats/graph?startDate=${this.searchStartDate}&endDate=${this.searchEndDate}`
					)
					.then(res => {
						this.datasetPackages = [
							{
								label: 'Colis vendus',
								backgroundColor: '#e55353',
								data: map(res.data.monthly, (item, key) => {
									return { x: key, y: item.quantity };
								}),
							},
						];

						this.datasetCA = [
							{
								label: 'CA (€)',
								backgroundColor: '#321fdb',
								data: map(res.data.monthly, (item, key) => {
									return { x: key, y: item.ca };
								}),
							},
						];

						this.totalsProductTypes = res.data.totals;

						this.loading = false;
					});
			},

			getMinDatasetDate(datasets) {
				let minFoundDate = null;
				for (let dataset of datasets) {
					let findLowestDate = minBy(dataset.data, function (o) {
						return o.x;
					});

					if (findLowestDate.x < minFoundDate || !minFoundDate) {
						minFoundDate = findLowestDate.x;
					}
				}

				return minFoundDate;
			},
		},
	};
</script>
